import {
  GET_ME_REQUEST,
  GET_ME_PRODUCTS_REQUEST,
  CLOSE_TWITTER_AUTHORIZATION_MODAL,
} from '../constants/action-types';

export const requestMe = () => ({
  type: GET_ME_REQUEST,
});

export const getMeProducts = () => ({
  type: GET_ME_PRODUCTS_REQUEST,
});

export const closeTwitterAuthorizationModal = () => ({
  type: CLOSE_TWITTER_AUTHORIZATION_MODAL,
});
